module.exports = __webpack_public_path__ + "static/media/circuit-bubble.a979d7e3.png";